import React, { useState } from "react";
import { X, Camera } from "lucide-react";

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_mk-urgence-auto/artifacts/negsiuii_IMG_4353.jpg",
    alt: "Remorquage Peugeot 207 en ville par MK Remorquage Perpignan",
    label: "Remorquage urbain",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mk-urgence-auto/artifacts/4r6gpgyb_IMG_4354.jpg",
    alt: "Convoi de plusieurs véhicules par MK Remorquage",
    label: "Transport multi-véhicules",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mk-urgence-auto/artifacts/tdjipan1_IMG_4355.jpg",
    alt: "Destruction de véhicule par MK Remorquage",
    label: "Destruction de véhicule",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mk-urgence-auto/artifacts/t56y0gkq_IMG_4356.jpg",
    alt: "Récupération VHU - épave en casse",
    label: "Récupération VHU",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_mk-urgence-auto/artifacts/xe7ihizd_483817235_1393908585316750_5080900416041301322_n.jpg",
    alt: "Volkswagen Taigo accidentée prise en charge par MK Remorquage",
    label: "Sinistre & accident",
  },
];

export const Gallery = () => {
  const [open, setOpen] = useState(null);

  return (
    <section id="galerie" className="relative py-24 sm:py-32 bg-[#0A0A0A]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">
            — Nos interventions
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
            Le travail<br />
            <span className="text-[#FFD600]">en images.</span>
          </h2>
          <p className="mt-5 text-neutral-400 text-lg max-w-2xl">
            Photos réelles de mes interventions à Perpignan et alentours. Du dépannage de proximité à la récupération
            d'épaves, tout est traité avec soin.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {PHOTOS.map((p, i) => (
            <button
              key={i}
              onClick={() => setOpen(i)}
              data-testid={`gallery-photo-${i}`}
              className={`group relative overflow-hidden rounded-lg border border-[#262626] hover:border-[#FFD600]/60 transition-all ${
                i === 0 ? "lg:col-span-2 lg:row-span-2 aspect-square" : "aspect-square"
              }`}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/0 to-black/0" />
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                <span className="text-xs font-bold uppercase tracking-wider text-white drop-shadow">
                  {p.label}
                </span>
                <Camera className="w-4 h-4 text-[#FFD600] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </button>
          ))}
        </div>
      </div>

      {open !== null && (
        <div
          className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-4 backdrop-blur-md"
          onClick={() => setOpen(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setOpen(null)}
            className="absolute top-5 right-5 h-12 w-12 rounded-full bg-[#FFD600] text-[#0A0A0A] flex items-center justify-center hover:scale-110 transition-transform"
            aria-label="Fermer"
          >
            <X className="w-6 h-6" strokeWidth={3} />
          </button>
          <img
            src={PHOTOS[open].src}
            alt={PHOTOS[open].alt}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
